export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">关于我们</h2>
            <p className="text-sm text-foreground-500">樱花动漫网的初心与坚持</p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-10">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              樱花动漫网成立于 2018 年，致力于为全球中文动漫爱好者提供<strong>免费、高清、无广告</strong>的在线动漫观看服务。
              我们深知追番的快乐不应被广告打断，因此平台始终坚持纯净观影体验，让每一位漫友都能沉浸在精彩的动漫世界中。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              经过多年发展，樱花动漫网已成长为覆盖<strong>日漫、国漫、剧场版、OVA</strong>等全类型的动漫资源平台，
              收录超过 3000 部动漫作品，涵盖热血、奇幻、恋爱、搞笑、悬疑等 20 余种分类。
              无论是热门完结动漫还是最新连载番剧，我们都在第一时间为大家更新。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              我们的团队由一群热爱动漫的年轻开发者组成，致力于将动漫文化传播到更广泛的群体。
              未来，樱花动漫网将继续优化产品体验，为动漫爱好者提供更丰富的<strong>好看的动漫免费在线看</strong>服务。
              感谢每一位漫友的支持与陪伴！
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}